import {
	SafeAreaView,
	Image,
	StyleSheet,
	Text,
	View,
	ScrollView,
	Pressable,
} from "react-native";
import React, { useEffect, useState } from "react";
import { useTheme } from "react-native-paper";
import { Ionicons } from "@expo/vector-icons";
import { ServicesStackProps } from "./ServicesStack";

const discontsSectionImage = require("../../../../assets/images/discountsSection.png");

const ServicesHub = ({ navigation }: ServicesStackProps) => {
	const { colors } = useTheme();

	return (
		<SafeAreaView style={styles.root}>
			<ScrollView
				style={[styles.sections, { backgroundColor: colors.pureWhite }]}
			>
				<View style={styles.holdDiscounts}>
					<Pressable
						onPress={() => navigation.navigate("Discounts")}
						style={styles.discounts}
					>
						<View style={styles.titleContainer}>
							<View>
								<Text style={styles.title}>Central de Descontos</Text>
							</View>
						</View>

						<Image source={discontsSectionImage} style={styles.bckImg} />
						<Ionicons
							name="ios-arrow-forward-circle"
							size={42}
							color="white"
							style={{ position: "absolute", zIndex: 3, top: 64, right: 14 }}
						/>
					</Pressable>
				</View>
			</ScrollView>
		</SafeAreaView>
	);
};

export default ServicesHub;

const styles = StyleSheet.create({
	root: {
		flex: 1,
		width: "100%",
	},
	sections: {
		flex: 1,
		width: "100%",
	},
	holdDiscounts: {
		flex: 1,
	},
	discounts: {
		width: "92%",
		height: 272,
		borderRadius: 20,
		marginHorizontal: "4%",
		marginTop: 25,
	},
	titleContainer: {
		height: 136,
		width: "100%",
		borderTopEndRadius: 20,
		borderTopStartRadius: 20,
		backgroundColor: "#C23961",
		padding: 30,
		position: "absolute",
		zIndex: 2,
	},
	bckImg: {
		borderRadius: 20,
		flex: 1,
		width: "100%",
	},
	title: {
		color: "#fff",
		fontWeight: "700",
		fontSize: 35,
		lineHeight: 38,
	},
});
